import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import SignUp from "./views/SignUp.vue";
import SignIn from "./views/SignIn.vue";
import Invite from "./views/Invite.vue";
import Settings from "./views/Settings.vue";
import Password from "./views/Password.vue";
import Update from "./views/Update.vue";
import KeyResultPage from "./views/KeyResultPage.vue";
import { auth } from "./firebase.config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: Dashboard
    },
    {
      path: "/key-result",
      name: "KeyResultPage",
      component: KeyResultPage
    },
    {
      path: "/sign-up",
      name: "signUp",
      component: SignUp
    },
    {
      path: "/sign-in",
      name: "signIn",
      component: SignIn
    },
    {
      path: "/invite",
      name: "invite",
      component: Invite
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "/password",
      name: "password",
      component: Password
    },
    {
      path: "/update",
      name: "update",
      component: Update
    },
    {
      path: "*",
      beforeEnter: (to, from, next) => {
        next("/");
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const isAuthenticating =
    to.path == "/sign-in" ||
    to.path == "/sign-up" ||
    to.path == "/password" ||
    to.path == "/invite";

  if (!auth.currentUser && (!isAuthenticating || to.path == "/update")) {
    next("/sign-up");
  } else if (auth.currentUser && isAuthenticating) {
    next("/");
  } else {
    next();
  }
});

export default router;
